var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-container"},[_c('router-view')],1),_c('the-footer',{key:_vm.$route.fullPath,class:_vm.$route.fullPath.match(/\w+/)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }